var map = {
	"./sazonal/abril_azul_-_autismo.svg": "70ba",
	"./sazonal/ano_novo.svg": "0bff",
	"./sazonal/dia_da_consciencia_negra.svg": "ccb6",
	"./sazonal/dia_da_independencia.svg": "23d0",
	"./sazonal/dia_das_criancas.svg": "0422",
	"./sazonal/dia_das_maes.svg": "64ca",
	"./sazonal/dia_de_tiradentes.svg": "6a93",
	"./sazonal/dia_do_amigo.svg": "2a03",
	"./sazonal/dia_do_consumidor.svg": "1769",
	"./sazonal/dia_do_orgulho_nerd.svg": "f53c",
	"./sazonal/dia_do_trabalho.svg": "05d1",
	"./sazonal/dia_dos_avos.svg": "d6a7",
	"./sazonal/dia_dos_namorados.svg": "35b8",
	"./sazonal/dia_dos_pais.svg": "7473",
	"./sazonal/dia_internacional_da_mulher.svg": "fce7",
	"./sazonal/natal.svg": "fc82",
	"./sazonal/novembro_azul.svg": "fb3e",
	"./sazonal/outubro_rosa.svg": "bd90",
	"./sazonal/pascoa.svg": "33ef",
	"./template/agronomia.svg": "1042",
	"./template/alta_performance_e_ajuda.svg": "1611",
	"./template/arquitetura_e_decoracao.svg": "f51f",
	"./template/artes.svg": "1f42",
	"./template/automoveis.svg": "2153",
	"./template/bebes_e_criancas.svg": "b342",
	"./template/beleza.svg": "892e",
	"./template/comida.svg": "9d35",
	"./template/direito.svg": "d262",
	"./template/educacao.svg": "d104",
	"./template/engenharia.svg": "ad9d",
	"./template/entretenimento.svg": "ec67",
	"./template/esporte_e_preparo_fisico.svg": "5025",
	"./template/filosofia_e_sociologia.svg": "e1ed",
	"./template/interacao.svg": "9873",
	"./template/jornalismo.svg": "a096",
	"./template/limpeza.svg": "a19e",
	"./template/memes.svg": "c54a",
	"./template/moda.svg": "a18b",
	"./template/moveis_e_imoveis.svg": "83a6",
	"./template/negocios_e_financas.svg": "37ff",
	"./template/pets.svg": "8064",
	"./template/saude_e_bem-estar.svg": "3de5",
	"./template/seguros.svg": "4514",
	"./template/tecnologia.svg": "9c20",
	"./template/turismo_e_viagem.svg": "9eb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f00c";